export { getDefaultTabId } from "./getDefaultTabId";
